export const ALL = 'all'

export const TRANSACTION_PAGE_PATH = '/transactions'
